module.exports = __webpack_public_path__ + "assets/Localizable.804c3dbbd18b4bb2f81a1312d605784d.strings";


//////////////////
// WEBPACK FOOTER
// ./src/resources/localizable/en-lproj/Localizable.strings
// module id = 1034
// module chunks = 0